import React, { Component } from "react";
import { connect } from "react-redux";
import { View } from "react-native";

import { Picker } from "components";

import { selectItemForOption } from "state/modules/response";
import { hideItemList } from "state/modules/survey";
import { markSelectedItems } from "state/modules/survey/selectors";

class ItemsPicker extends Component {
  getItems = () => {
    const { items, linkedOptionForItem, response } = this.props;
    return markSelectedItems(items, linkedOptionForItem, response);
  };

  render = () => {
    const items = this.getItems();

    return (
      <View>
        <Picker
          visible={this.props.showItemsList}
          options={items}
          textKey="name"
          onPress={item => this.props.selectItemForOption(item.id)}
          dismiss={this.props.hideItemList}
        />
      </View>
    );
  };
}

const mapDispatchToProps = {
  hideItemList,
  selectItemForOption,
};

const mapStateToProps = state => {
  return {
    response: state.response,
    items: state.survey.items,
    showItemsList: state.survey.showItemsList,
    linkedOptionForItem: state.survey.linkedOptionForItem,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ItemsPicker);
